

export function mercatorToLonLat(x, y) {
  const R = 6378137.0; // Earth's radius in meters
  const lon = (x / R) * (180 / Math.PI);
  const lat = (2 * Math.atan(Math.exp(y / R)) - Math.PI / 2) * (180 / Math.PI);
  return [lon, lat];
}
